import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { galleryPreview } from "../../data/gallery";
import { GalleryGrid } from "../GalleryGrid";
import { Reveal } from "../Reveal";

export const GalleryPreview = () => (
  <section className="px-5 py-16 md:py-24" data-testid="gallery-preview">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-script text-3xl text-hotpink">the proof</p>
          <h2 className="mt-2 font-serif text-4xl md:text-5xl">Recent Looks</h2>
        </div>
        <Link
          to="/gallery"
          className="group flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-white/60 transition-colors duration-300 hover:text-hotpink"
          data-testid="gallery-preview-view-all"
        >
          View full gallery
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>

      <GalleryGrid items={galleryPreview} />
    </div>
  </section>
);

